import { z, ZodStringDef, ZodType } from 'zod/v3';
import { UUIDType } from '../randomUniqueKey';

export const zUniqueKey = (...args: Parameters<typeof z.string>) =>
  z.string(...args).uuid() as ZodType<UUIDType, ZodStringDef>;
